var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.processing && _vm.is_disabled)?[_c('a',{attrs:{"href":_vm.base_url+'?name='+_vm.status}},[_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.status)+" Messages Disabled")])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }